import axiosInstance from '../helpers/axios';
import { getToken } from './auth';

// Search for a call based on a query
export const searchCall = async query => {
    const token = getToken();
    return await axiosInstance({
        method: 'get',
        url: `/api/client/call/?search=${query}`,
        headers: { Authorization: 'Bearer ' + token },
    });
};

// List all calls
export const getCalls = async () => {
    const token = getToken();
    return await axiosInstance({
        method: 'get',
        url: '/api/client/call/',
        headers: { Authorization: 'Bearer ' + token },
    });
};

// Get specific call by ID
export const getCallById = async id => {
    const token = getToken();
    return await axiosInstance({
        method: 'get',
        url: `/api/client/call/${id}`,
        headers: { Authorization: 'Bearer ' + token },
    });
};

// Create a new call
export const createCall = async data => {
    const token = getToken();
    return await axiosInstance({
        method: 'post',
        url: '/api/client/call/',
        headers: { Authorization: 'Bearer ' + token },
        data,
    });
};

// Update a call by ID
export const updateCall = async (id, data) => {
    const token = getToken();
    return await axiosInstance({
        method: 'put',
        url: `/api/client/call/${id}`,
        headers: { Authorization: 'Bearer ' + token },
        data,
    });
};

// Delete a call by ID
export const deleteCall = async id => {
    const token = getToken();
    return await axiosInstance({
        method: 'delete',
        url: `/api/client/call/${id}`,
        headers: { Authorization: 'Bearer ' + token },
    });
};

// Generate summary report of calls within a date range
export const getCallsSummaryReport = async (date1, date2) => {
    const token = getToken();
    return await axiosInstance({
        method: 'get',
        url: `/api/client/summary-calls?date_1=${date1}&date_2=${date2}`,
        headers: { Authorization: 'Bearer ' + token },
        responseType: 'blob',
    });
};

// Get CRM summary report filtered by date or date range
export const getCrmSummary = async (date, dateRange) => {
    const token = getToken();
    let url = '/api/client/crm-summary';

    if (date) {
        url += `?date=${date}`;
    } else if (dateRange) {
        url += `?date_range=${dateRange}`;
    }

    return await axiosInstance({
        method: 'get',
        url: url,
        headers: { Authorization: 'Bearer ' + token },
    });
};